import React, { ComponentProps } from 'react';
import CSSTransition from 'react-transition-group/CSSTransition';
import SwitchTransition from 'react-transition-group/SwitchTransition';
import computeDynamicDomId from 'utils/functions/computeDynamicDomId';
import usePreviousValue from 'utils/hooks/usePreviousValue';
import { cssTransitionClassNames } from '../SlideInMenu.config';
import { TabContentProps } from '../SlideInMenu.type';
import {
  ExpandedTabContentGrid,
  MenuCardOnRails,
} from '../style/ExpandedSlideInMenu.style';

const addEndListener: ComponentProps<typeof CSSTransition>['addEndListener'] = (
  node,
  done,
) => node.addEventListener('transitionend', done, false);

const ExpandedTabContent = React.memo(function ExpandedTabContent({
  navbarContent,
  activeTabIndex,
  domIdPrefix,
  isActive,
}: TabContentProps) {
  const previousIsActive = usePreviousValue(isActive);
  const isFirstTab = isActive && !previousIsActive;
  const cards = navbarContent?.menuTab?.[activeTabIndex]?.cards;

  return (
    <SwitchTransition>
      <CSSTransition
        timeout={200}
        key={activeTabIndex ?? 0}
        addEndListener={addEndListener}
        classNames={cssTransitionClassNames}
      >
        <ExpandedTabContentGrid
          role={'tabpanel'}
          id={computeDynamicDomId(domIdPrefix, 'tab-panel')}
          data-first-tab={isFirstTab ? 'true' : undefined}
          aria-labelledby={computeDynamicDomId(
            domIdPrefix,
            activeTabIndex ?? 0,
          )}
        >
          {cards &&
            cards.map((card, index) => (
              <MenuCardOnRails key={index} menuCard={card} />
            ))}
        </ExpandedTabContentGrid>
      </CSSTransition>
    </SwitchTransition>
  );
});

export default ExpandedTabContent;
